(function ($, Drupal, drupalSettings) {
  'use strict';

  Drupal.behaviors.playcationDestinationsView = {
    attach: function (context, settings) {
      // Universal Vars
      const playcationContainer = document.querySelector('.landing-page--playcation .view-content.hide-extra');
      const viewsItems = document.querySelectorAll('.landing-page--playcation .view-content.hide-extra .views-row');
      let playcationItems;

      // Initialize filters
      Drupal.behaviors.playcationDestinationsView.applyFilters('all');

      // Toggle filters dropdown
      $('.play-filter--closed').click(function () {
        Drupal.behaviors.playcationDestinationsView.toggleFilters();
      });

      // Apply filters
      $('.play-filter--option').click(function () {
        // GA event - filtering
        dataLayer.push({
          eventCategory: 'playcation family hub- all destinations',
          eventAction: 'filter by area',
          eventLabel: $(this).attr('value'),
          eventvalue: '',
          event: 'eventClick'
        });

        Drupal.behaviors.playcationDestinationsView.applyFilters($(this).attr('value'));
        $('.play-filter--closed').text($(this).text());
        $('.play-filter--option.selected').removeClass('selected');
        $(this).addClass('selected');
        Drupal.behaviors.playcationDestinationsView.toggleFilters();

        // Hide | Show on re-filter
        playcationItems = playcationContainer.querySelectorAll('.views-row:not([hidden])');

        if ($('.landing-page--playcation .view-button .button').text() === 'Show Less') {
          $('.landing-page--playcation .view-button .button').text('Load More');
        }

        viewsItems.forEach((div) => {
          div.removeAttribute('style');
        });

        if (playcationItems.length <= 6) {
          $('.landing-page--playcation .view-button').hide();
        }
        else {
          $('.landing-page--playcation .view-button').show();
          for (let i = 6; i < playcationItems.length; i++) {
            playcationItems[i].style.display = 'none';
          }
        }
      });

      // Close filters when clicking away.
      $(document).mouseup(function (e) {
        if ($(e.target).closest('.play-filter').length === 0) {
          $('.play-filter').removeClass('open');
        }
      });

      // Show/Hide
      $(document).ready(function () {
        let playcationItems = playcationContainer.querySelectorAll('.views-row:not([hidden])');
        Drupal.behaviors.playcationDestinationsView.playcationHideShow(playcationItems);
      });

      $('.landing-page--playcation .view-button .button').click(function () {
        let playcationItems = playcationContainer.querySelectorAll('.views-row:not([hidden])');
        let viewContent = $('.view-content');

        $(this).text(($(this).text() === 'Load More') ? 'Show Less' : 'Load More');

        if (viewContent.hasClass('hide-extra')) {
          viewContent.removeClass('hide-extra');
          viewsItems.forEach((div) => {
            div.removeAttribute('style');
          });
        }
        else {
          viewContent.addClass('hide-extra');
          Drupal.behaviors.playcationDestinationsView.playcationHideShow(playcationItems);
        }
      });
    },

    playcationHideShow: function (playcationItems) {
      if (playcationItems.length >= 6) {
        for (let i = 6; i < playcationItems.length; i++) {
          playcationItems[i].style.display = 'none'; // Hides the <div>
        }
        $('.landing-page--playcation .view-button').show();
      }
      else {
        $('.landing-page--playcation .view-button').hide();
      }
    },

    toggleFilters: function () {
      $('.play-filter').toggleClass('open');
    },

    applyFilters: function (filterValue) {
      // Reset filters
      $('.view-display-id-block_1.view-playcation-destinations .views-row').removeAttr('hidden');

      if (filterValue !== 'all') {
        $('.node--playcation-destination-page-teaser[data-location!=' + filterValue + ']').closest('.views-row').attr('hidden', '');
        $('.node--playcation-destination-page-teaser[data-location=statewide]').closest('.views-row').removeAttr('hidden');
      }
    }
  };

})(jQuery, Drupal, drupalSettings);

